import { FaLayerGroup, FaHardHat, FaHandsHelping } from "react-icons/fa";

const whyChooseUs = {
  sub: "Why Choose Us",
  heading: "Elevate Your Space with Superior Flooring, Tiling, and Paving Solutions",
  content: "At Flooring Masters, we're committed to transforming your space with our exceptional flooring, tiling, and paving services.",
  points: [
    {
      id: 1,
      icon: <FaLayerGroup />, // Custom Solutions icon
      title: "Custom Solutions",
      content: "We provide customized flooring, tiling, and paving solutions tailored to your specific preferences and space requirements.",
    },
    {
      id: 2,
      icon: <FaHardHat />, // Quality Assurance icon
      title: "Quality Assurance",
      content: "Our team ensures top-notch quality in every project, guaranteeing durable and aesthetically pleasing results for your space.",
    },
    {
      id: 3,
      icon: <FaHandsHelping />, // Professional Team icon
      title: "Professional Team",
      content: "Backed by a team of skilled professionals, we deliver expert installation and craftsmanship, ensuring satisfaction with every project.",
    },
  ],
};

export default whyChooseUs;